export default __webpack_public_path__ + "3327fa6c8d602aebae9b6f98170f78ad.png";